export default __webpack_public_path__ + "static/media/certificate-two.5ba1e718.png";